import { render } from "./ListTopicView.vue?vue&type=template&id=3fd2ae00"
import script from "./ListTopicView.vue?vue&type=script&lang=js"
export * from "./ListTopicView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__